module.exports = __webpack_public_path__ + "static/nba-logo-a0fc73684ce3ba3806a7d038105068bb.png";